import React from 'react';

import Navbar from '../../global/Navbar';

import Footer from '../../global/Footer';

import Newsletter from '../../global/Newsletter';

import { PageFlow } from '../../shared/SectionSurface';
import { PBIHero, PBISections } from './PBIContent';
import PageMeta from '../../shared/PageMeta';



function Overview() {



  return (

    <div>

      <PageMeta path="/interactive-analytics" />

      <Navbar />

      <PageFlow>
        <PBIHero />
        <PBISections />
      </PageFlow>

      <Newsletter />

      <Footer />

    </div>

  );

}



export default Overview;

